export enum StorybookURLs {
  Local = "http://localhost:6006",
  Development = "https://storybook-dev.forestholidays.co.uk",
  QA = "https://storybook-qa.forestholidays.co.uk",
}
